
import { App } from '@capacitor/app';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

// Helper function to extract path from URL
const getPathFromUrl = (url: string): string => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname;
  } catch (e) {
    console.error('Failed to parse URL:', url, e);
    return '/';
  }
};

// Hook to handle app URLs and deep links
export const useAppUrlListener = () => {
  const navigate = useNavigate();
  const isCapacitorApp = Capacitor.isNativePlatform();
  
  useEffect(() => {
    if (!isCapacitorApp) return;
    
    const handleUrlOpen = async (urlOpenData: { url: string }) => {
      console.log('App URL opened:', urlOpenData.url);
      const path = getPathFromUrl(urlOpenData.url);
      
      // Navigate to the path using React Router
      if (path) {
        console.log('Navigating to path from app URL:', path);
        navigate(path);
      }
    };
    
    // Add listener for URL opens (deep links)
    App.addListener('appUrlOpen', handleUrlOpen);
    
    // Get the initial URL if the app was launched with one
    const checkInitialUrl = async () => {
      try {
        const { url } = await App.getLaunchUrl();
        if (url) {
          console.log('App launched with URL:', url);
          const path = getPathFromUrl(url);
          if (path) navigate(path);
        }
      } catch (error) {
        console.error('Error getting launch URL:', error);
      }
    };
    
    checkInitialUrl();
    
    // Clean up listener when component unmounts
    return () => {
      App.removeAllListeners();
    };
  }, [navigate, isCapacitorApp]);
};
